import { render, staticRenderFns } from "./DictionaryCourseEffects.vue?vue&type=template&id=d7359cde&"
import script from "./DictionaryCourseEffects.vue?vue&type=script&lang=js&"
export * from "./DictionaryCourseEffects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports